<template>
  <div class="toppage-scrolltop-base">
    <scroll-top></scroll-top>
  </div>
</template>

<script>
export default {
  name: "ToppageScrollTop"
}
</script>

<style scoped lang="scss">
@import "../../../sass/variables/index";
.toppage-scrolltop-base {
  padding: 40px 6px;
  background: $gray-15;
  box-sizing: border-box;
  width: 100%;
  /deep/ .scroll_top {
    margin-bottom: 0;
    .scroll_top__container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ToppageScrollTop.vue